import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import {
  MatFormField,
  MatLabel,
  MatOption,
  MatSelect,
} from '@angular/material/select'
import { SupplyChain } from '../../../types/supplyChain'
import { Product, ProductComponent } from '../../../types/products'
import { MatDivider } from '@angular/material/divider'
import { MatIcon } from '@angular/material/icon'
import { MatToolbar } from '@angular/material/toolbar'
import { ActivatedRoute, RouterModule } from '@angular/router'
import { RouteService } from '../../../services/route.service'
import { ROUTES } from '../../../constants/routes'

@Component({
  selector: 'app-product-supply-chain',
  imports: [
    MatSelect,
    MatOption,
    MatFormField,
    MatLabel,
    MatDivider,
    MatIcon,
    MatToolbar,
    RouterModule,
  ],
  templateUrl: './product-supply-chain.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './product-supply-chain.component.scss',
})
export class ProductSupplyChainComponent implements OnInit {
  private route = inject(ActivatedRoute)

  constructor() {
    const routeService = inject(RouteService)

    const productId = this.route.parent?.snapshot.params['id']
    if (!productId) {
      // TODO - throw error
    }

    const currentRoute = routeService.getProductViewRoutes(
      this.product.name,
      ROUTES.PRODUCT_SUPPLY_CHAIN.path,
      productId,
    )
    routeService.setRoute(currentRoute)
  }

  supplyChain: SupplyChain = {
    provDescription:
      'Made in Nova Scotia, home of the BlueNose - the greatest racing all-sail schooner of its time and multi-time winner of the international ' +
      "Fisherman's Trophy.",
    tracedThroughCoc: true,
    isAuthenticated: true,
    components: [
      {
        name: 'Entire Item',
        transactions: [
          {
            name: 'Registered',
            companyName: 'Helly Hansen',
          },
          {
            name: 'Start Custody',
            companyName: 'Helly Hansen',
          },
          {
            name: 'Received Custody',
            companyName: 'Company 2',
          },
          {
            name: 'Start Custody',
            companyName: 'Company 2',
          },
          {
            name: 'Received Custody',
            companyName: 'Company 3',
          },
        ],
      },
      {
        name: 'Zipper',
        transactions: [
          {
            name: 'Registered',
            companyName: 'Zipper Company',
          },
          {
            name: 'Start Shipment',
            companyName: 'Zipper Company',
          },
          {
            name: 'Receive Shipment',
            companyName: 'Helly Hansen',
          },
          {
            name: 'Start Transformation',
            companyName: 'Helly Hansen',
          },
          {
            name: 'Complete Transformation',
            companyName: 'Helly Hansen',
          },
        ],
      },
    ],
  }
  product: Product = {
    name: "Men's Skagen Offshore Sailing Jacket",
    id: '007',
    brand: 'Helly Hansen',
  }

  selectedComponent!: ProductComponent

  ngOnInit(): void {
    this.selectedComponent = this.supplyChain.components[0]

    if (!this.selectedComponent) {
      // TODO - throw error
    }
  }
}
